<!--零星预测-零星预测-父项-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="materialNo"
          ref="materialNoRef"
          :assembleLabel="false"
          :value.sync="queryParams.materialNo"
          selectType="selectSearch"
          requestApi="/mes/mesDiscreteJobs/assemblyBox"
          :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
          searchParam="itemCode" />
        <global-select
          slot="demandBillNo"
          ref="demandBillNoRef"
          :value.sync="queryParams.demandBillNo"
          selectType="selectSearch"
          requestApi="/scp/scpFcSporadic/sourceCodeList"
          :selectItem="{ value: 'label', label: 'label' }"
          searchParam="inputString" />
        <global-select
          slot="businessTeamName"
          ref="businessTeamNameRef"
          :value.sync="queryParams.businessTeamName"
          selectType="selectSearch"
          requestApi="/system/lookup/data/likeList"
          :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
          :setParams="{ lookupType: 'SCP_BUSINESS_UNIT' }"
          searchParam="lookupValue"
          :dropdown-match-select-width="false"
        />
        <global-select
          slot="createUserNo"
          ref="createUserNoRef"
          selectType="selectAssembleSearchByKey"
          :value.sync="queryParams.createUserNo"
          requestApi="/scp/scpFcSporadic/applicantBox"
          :selectItem="{ value: 'realValue', label: 'selectedValue' }"
          :showLabel="{ value: 'realValue', label: 'label', selectedValue: 'selectedValue' }"
          searchParam="name"
        />
        <a-select
          slot="projectTeamName"
          :max-tag-count="1"
          show-search
          allowClear
          option-filter-prop="children"
          v-model="queryParams.projectTeamName" >
          <a-select-option v-for="(item) in projectTeams" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
        </a-select>
        <global-select
          slot="demandType"
          ref="demandTypeRef"
          selectType="selectSearch"
          :value.sync="queryParams.demandType"
          requestApi="/scp/scpDemandPlacementBill/demandTypeCombobox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="demandType"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" :loading="loading" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 2000 }">
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import {
  apiGetSopGiftDemandOriginalDetailListPage
} from '@/api/scp/sporadic-demand/sporadic-forecast'
import cacheRequest from '@/mixins/cacheRequest'

export default {
  name: 'SporadicForecastParent',
  mixins: [cacheRequest],
  data() {
    return {
      loading: false,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetSopGiftDemandOriginalDetailListPage, false),
        pageCurrent: true
      },
      projectTeams: [], // 项目组
      // 查询参数
      queryParams: {
        materialNo: undefined,
        demandBillNo: undefined,
        businessTeamName: undefined,
        projectTeamName: undefined,
        demandType: undefined,
        createUserNo: undefined,
        submitTime: undefined,
        submitTimeStart: undefined,
        submitTimeEnd: undefined
      },
      formList: [
        { label: '物料编码', decorator: ['materialNo'], type: 'materialNo' },
        { label: '来源编号', decorator: ['demandBillNo'], type: 'demandBillNo' },
        { label: '事业部', decorator: ['businessTeamName'], type: 'businessTeamName' },
        { label: '项目组', decorator: ['projectTeamName'], type: 'projectTeamName' },
        { label: '需求类型', decorator: ['demandType'], type: 'demandType' },
        { label: '申请人', decorator: ['createUserNo'], type: 'createUserNo' },
        {
          label: '申请时间',
          type: 'range',
          decorator: ['submitTime'],
          disposeFormat: {
            submitTimeStart: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            submitTimeEnd: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        }
      ],
      // 表格字段
      columns: [
        { title: '物料编码', dataIndex: 'materialNo', align: 'center', width: 120, stickyFixed: 'left' },
        { title: '物料名称', dataIndex: 'materialName', align: 'center', width: 100 },
        { title: '下单类别', dataIndex: 'orderCategory', align: 'center', width: 90 },
        { title: '销售类目', dataIndex: 'saleCategory', align: 'center', width: 90 },
        { title: '研发分类', dataIndex: 'developedTypeName', align: 'center', width: 90 },
        { title: '口径', dataIndex: 'caliberStr', align: 'center', width: 100 },
        { title: '是否停产', dataIndex: 'stopIsStr', align: 'center', width: 80 },
        { title: '主型号', dataIndex: 'mainModel', align: 'center', width: 100 },
        { title: '需求数量', dataIndex: 'demandQuantity', align: 'center', width: 90 },
        {
          title: '需求交期',
          dataIndex: 'demandDeliveryTime',
          align: 'center',
          width: 100,
          customRender: (text) => this.$moment(text).format('YYYY-MM-DD')
        },
        { title: '当月回货需求', dataIndex: 'curMonthReturnDemand', align: 'center', width: 100 },
        { title: '当月回货需求日期', dataIndex: 'curMonthReturnDemandDate', align: 'center', width: 100 },
        { title: '次月回货需求', dataIndex: 'nextMonthReturnDemand', align: 'center', width: 100 },
        { title: '次月回货需求日期', dataIndex: 'nextMonthReturnDemandDate', align: 'center', width: 100 },
        { title: '供应余量', dataIndex: 'supplyRemainQty', align: 'center', width: 90 },
        { title: '是否在锁定期内', dataIndex: 'inLockFlagStr', align: 'center', width: 90 },
        { title: '是否提需求', dataIndex: 'commitDemandIsStr', align: 'center', width: 90 },
        { title: '需求类型', dataIndex: 'demandTypeStr', align: 'center', width: 100 },
        { title: 'M+3月预测数量', dataIndex: 'forecastQtyM3', align: 'center', width: 100 },
        { title: 'M+2月预测数量', dataIndex: 'forecastQtyM2', align: 'center', width: 100 },
        { title: 'M+1月预测数量', dataIndex: 'forecastQtyM1', align: 'center', width: 100 },
        { title: '三个月内是否可消耗完', dataIndex: 'threeMonthConsumeIsStr', align: 'center', width: 100 },
        { title: '预计消耗月数', dataIndex: 'expectConsumeMonth', align: 'center', width: 90 },
        { title: '需求备注', dataIndex: 'demandComment', align: 'center', width: 120 },
        { title: '项目组', dataIndex: 'projectTeamName', align: 'center', width: 110 },
        { title: '事业部', dataIndex: 'businessTeamName', align: 'center', width: 120 },
        { title: '销售利润分类', dataIndex: 'salesProfitClassification', align: 'center', width: 110 },
        { title: '来源单号', dataIndex: 'demandBillNo', align: 'center', width: 170 },
        { title: '单据备注', dataIndex: 'remark', align: 'center', width: 160 },
        { title: '申请人', dataIndex: 'createUserName', align: 'center', width: 90 },
        { title: '申请时间', dataIndex: 'submitTime', align: 'center', width: 140 }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('SCP_PROJECT_TEAM', { lookupType: 'SCP_PROJECT_TEAM', current: 1, pageSize: 999 }, 'projectTeams')
  },
  mounted() {
    this.loading = false;
    this.onSearch()
  },
  methods: {
    // 导出
    handleExport() {
      this.$message.loading('导出中..', 0.5)
      const params = this.$refs.dataTable.searchParams
      this.downloadByJson('/external/scm/exportSopGiftDemandOriginalDetailData', {
        ...params
      }, `零星需求申请记录导出_${new Date().getTime()}.xlsx`)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        materialNo: undefined,
        demandBillNo: undefined,
        businessTeamName: undefined,
        projectTeamName: undefined,
        demandType: undefined,
        createUserNo: undefined,
        submitTime: undefined,
        submitTimeStart: undefined,
        submitTimeEnd: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      if(this.$refs?.demandTypeRef) this.$refs.demandTypeRef.handleSearch('');
      if(this.$refs?.materialNoRef) this.$refs.materialNoRef.handleSearch('');
      if(this.$refs?.demandBillNoRef) this.$refs.demandBillNoRef.handleSearch('');
      if(this.$refs?.businessTeamNameRef) this.$refs.businessTeamNameRef.handleSearch('');
      if(this.$refs?.createUserNoRef) this.$refs.createUserNoRef.handleSearch('');
    }
  }
}
</script>

<style scoped lang="less"></style>
